import { AppLayout } from "@/ui/layouts/AppLayout"
import { PageTitle } from "@/ui/components/ui/page-title"
import { AccordionGroup, AccordionItem } from "@/ui/components/ui/accordion-group"

const contactEmail = import.meta.env.VITE_CONTACT_EMAIL || "support@anyw3ar.com"

/**
 * FAQ items for the support page
 */
const faqItems: AccordionItem[] = [
  {
    question: "How do I pair a new item?",
    answer: "Simply follow the link to the \"Scan a New Item\" page and pair it in a few seconds.",
  },
  {
    question: "How do I unpair an item?",
    answer: "Open your collection, find the item, and tap the Unpair button next to it.",
  },
  {
    question: "I lost an item, what can I do?",
    answer: "Unpair the item by selecting the \"Stolen\" option. Our team will contact you afterward.",
  },
  {
    question: "How can I make my information private?",
    answer: "Go to your profile and switch your visibility to \"Not Public.\"",
  },
  {
    question: "Do I have to fill out my entire profile?",
    answer: "Don't worry, nothing is mandatory (except your style!). Fill in only what you want and choose exactly what you want to show. Your profile should match your vibe, anytime.",
  },
  {
    question: "Which music platforms can I link to my profile?",
    answer: "You can connect: Deezer, Spotify, SoundCloud, YouTube Music, Apple Music and Amazon Music.",
  },
  {
    question: "How is my data used?",
    answer: "By signing up, you agreed to our Privacy & Data Policy, which states:\n• We may contact you by phone only for service-related updates.\n• Public wallet information may be shared with partners solely to send you gifts (free of charge).\n• Your data is never sold or used outside these purposes.",
  },
]

/**
 * Support page - accessible without authentication
 *
 * Displays FAQ accordion items to help users find answers
 * to common questions about ANYW3AR.
 */
export default function SupportPage() {
  return (
    <AppLayout>
      <PageTitle>Need help?</PageTitle>

      {/* Introduction text */}
      <div className="text-gray-700 text-[0.9375rem] font-montserrat leading-[1.25rem] mb-8">
        <p className="mb-4">
          Find everything you need in our FAQ. If your answer isn't there, just reach out:{" "}
          <a
            href={`mailto:${contactEmail}`}
            className="text-brand-red hover:underline"
          >
            {contactEmail}
          </a>
        </p>
        <p className="font-medium">
          Your patch, your choice. Your questions, our support.
        </p>
      </div>

      {/* FAQ Accordion */}
      <AccordionGroup items={faqItems} />
    </AppLayout>
  )
}
